export const smsCampaignStatus = {
  DRAFT: "statusBlock",
  SCHEDULED: "statusBlock--pending",
  ONGOING: "statusBlock--purple",
  COMPLETED: "statusBlock--success",
  SENT: "statusBlock--success",
  PAUSED: "statusBlock--pending",
  CANCELLED: "statusBlock--failed",
};
